export type LoginPayload = {
  authToken: string;
  identityId?: string;
};

export enum LoginError {
  IDENTITY_NOT_FOUND = 1,
  PHONE_VALIDATION_REQUIRED,
  WRONG_VALIDATION_CODE,
  COMPANY_SELECTION_REQUIRED,
  IDENTITY_SELECTION_REQUIRED,
  PASSWORD_VALIDATION_REQUIRED,
  WRONG_PASSWORD,
  PHONE_VALIDATION_FAILED,
}

export type LoginResponse = {
  errorCode?: LoginError;
  errorData?: any;
  success?: boolean;
};

export type UserIdentity = {
  id: string;
  userId: number;
  userName: string;
};
